export interface Pessoa {
  id: number;
  nome: string;
  setor: string;
}

export interface OpcaoResponsavel {
  label: string;
  value: string;
  disabled?: boolean;
  workingsector?: string;
  style?: string;
  listStyle?: string;
}

export interface GrupoResponsaveis {
  label: string;
  items: OpcaoResponsavel[];
}

export type Setor = string | string[];

export const habilitadoNoSetor = (setor: Setor, setorDaPessoa: string): boolean => setor === 'all' || setor.includes(setorDaPessoa);

interface Entrada {
  todos: GrupoResponsaveis;
  advogados: Pessoa[];
  assistentes?: Pessoa[];
  setor: Setor;
  estiloLista?: string;
}

// Monta do zero os grupos do dropdown "Responsável". Sempre devolve uma lista nova.
export const montarGrupos = ({
  todos, advogados, assistentes, setor, estiloLista,
}: Entrada): GrupoResponsaveis[] => {
  const grupos: GrupoResponsaveis[] = [todos];

  grupos.push({
    label: 'Advogados',
    items: advogados.map((pessoa) => ({
      label: `${pessoa.nome} (Advogado)`,
      value: `adv|${pessoa.id}`,
      disabled: !habilitadoNoSetor(setor, pessoa.setor),
      workingsector: pessoa.setor,
      ...(estiloLista ? { listStyle: estiloLista } : {}),
    })),
  });

  if (assistentes) {
    grupos.push({
      label: 'Assistentes/Estagiários',
      items: assistentes.map((pessoa) => ({
        label: `${pessoa.nome} (Assistente)`,
        value: `adm|${pessoa.id}`,
        disabled: !habilitadoNoSetor(setor, pessoa.setor),
        workingsector: pessoa.setor,
        style: 'visibility: hidden',
      })),
    });
  }

  return grupos;
};
